module.exports = "<svg viewBox=\"0 0 24 24\"\n    [ngClass]=\"{checked: value()}\"\n    (click)=\"toggle()\">\n    <polyline points=\"7,13 9.5,15.5 17,8.5\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./~/text-loader!./_src/ui/elements/checkbox.html
// module id = 504
// module chunks = 1 4